import React from "react"
import { APlayer } from "aplayer-react"
import "aplayer-react/dist/index.css"

type NeteaseCloudMusicSong = {
  id: number
  name: string
  mediaUrl: string
  ar: NeteaseCloudMusicArtist[]
  al: NeteaseCloudMusicAlbum
  lrc: string
}

type NeteaseCloudMusicArtist = {
  id: number
  name: string
}

type NeteaseCloudMusicAlbum = {
  picUrl: string
}

type NetEaseMusicPlayerProps = {
  songs: readonly NeteaseCloudMusicSong[]
}

export function NetEaseMusicPlayer({ songs }: NetEaseMusicPlayerProps) {
  return (
    <APlayer
      audio={songs.map(songInfo => ({
        name: songInfo.name,
        artist:
          songInfo.ar.length > 1
            ? songInfo.ar.map(artist => artist.name).join("/")
            : {
                name: songInfo.ar[0].name,
                url: `https://music.163.com/#/artist?id=${songInfo.ar[0].id}`,
              },
        url: songInfo.mediaUrl,
        cover: songInfo.al.picUrl,
        lrc: songInfo.lrc,
      }))}
      theme="auto"
      autoPlay
    />
  )
}
